// This Hook will toggle a class "online-user" if the user
// specified with `data-user-id` is online or not.
import OnlinePresence from "../online_presence"

export const OnlineUser = {
  mounted() {
    this.subscription = OnlinePresence.subscribe(
      this.el.dataset.userId,
      (isOnline) => this.refresh(isOnline),
    )
  },
  destroyed() {
    OnlinePresence.unsubscribe(this.subscription)
  },
  refresh(isOnline) {
    this.el.classList.toggle("online-user", isOnline)
  },
}
